var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.082,
    height: 52.082,
    viewBox: "0 0 52.082 52.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.082 35.247a16.874 16.874 0 0 0-12.328-16.223A19.886 19.886 0 1 0 2.758 30L.073 39.7l9.705-2.684a19.813 19.813 0 0 0 9.245 2.737 16.84 16.84 0 0 0 24.789 9.989l8.2 2.267-2.267-8.2a16.775 16.775 0 0 0 2.337-8.562zM10.26 33.716l-5.81 1.608 1.607-5.81-.366-.573a16.829 16.829 0 1 1 5.142 5.142zm37.372 13.916l-4.311-1.193-.576.375A13.789 13.789 0 0 1 22.18 39.64a19.924 19.924 0 0 0 17.461-17.461 13.789 13.789 0 0 1 7.173 20.566l-.375.576zm0 0",
    "data-name": "Path 128"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.361 27.567h3.052v3.052h-3.052zm0 0",
    "data-name": "Path 129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.938 15.255a3.02 3.02 0 0 1-.993 2.253l-3.584 3.281v3.724h3.052v-2.38l2.593-2.373a6.1 6.1 0 1 0-10.223-4.505h3.052a3.052 3.052 0 1 1 6.1 0zm0 0",
    "data-name": "Path 130"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.da362a5a8ff461b9d9b3875b7ab0823f.svg";
export { ForwardRef as ReactComponent };